<template>
  <div class="ban_top">
    <img :src="headimgurl" alt="头像" />
    <h2>
      {{nickname}}
      <small v-show="uid">({{uid}})</small>
    </h2>
  </div>
</template>
<script>
import {
  my
} from "@/api/person";
export default {
  data() {
      return {}
    },
    props: {
      uid: {
        type: String,
        default: ''
      },
      headimgurl: {
        type: String,
        default: ""
      },
      nickname: {
        type: String,
        default: ""
      }
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.ban_top {
  text-align: center;
  width: 100%;
  height: changeRem(5)+px;
  background: url(../assets/ba_top.png) no-repeat top center;
  background-size: cover;
  padding-top: changeRem(0.85)+px;
  img {
    width: changeRem(2)+px;
    height: changeRem(2)+px;
    border-radius: 50%;
  }
  h2 {
    font-size: changeRem(0.68)+px;
    color: #fff;
    margin-top: 0.6rem;
  }
}
</style>
